<template>
    <span>
        <b-button
            variant="primary"
            @click.stop="confirmarEnviarFinalizacao()"
            v-if="mostrarBtnEnviarParaAprovacao"
        >
            <span>
                <i class="fa fa-arrow-circle-right"></i> Enviar para aprovação
            </span>
        </b-button>
        <span class="ml-2" v-if="mostrarMensagem">
            <strong
                >Fora do prazo permitido de envio para aprovação. Liberado a
                partir de
                {{ $maskDate(finalizacao.dataEnvioPermitido) }}.</strong
            >
        </span>
    </span>
</template>

<script>
export default {
    props: {
        finalizacao: {
            type: Object,
            required: true
        },

        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarEnviarFinalizacao() {
            this.$swal({
                title: 'Envio para Aprovação',
                html: `Confirma o envio do registro de pagamento para aprovação?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.enviarFinalizacaoParaAprovacao()
                }
            })
        },

        enviarFinalizacaoParaAprovacao() {
            let finalizacaoParaAprovacao = {
                finalizacaoId: this.finalizacao.finalizacaoId
            }
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .enviarFinalizacaoParaAprovacao(finalizacaoParaAprovacao)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterFinalizacaoAtualizada')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERRO',
                                this.$toastConfig.error
                            )
                            // this.$emit('atualizarErros', response.errors)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnEnviarParaAprovacao() {
            return (
                (this.finalizacao.status === 0 ||
                    this.finalizacao.status === 5) &&
                (this.finalizacao.qtdEntregas > 0 ||
                    this.finalizacao.qtdDespViagens > 0) &&
                this.finalizacao.qtdAnexos > 0 &&
                this.$temAcesso('CRED-FORN-FIN-04') &&
                this.finalizacao.envioPermitido
            )
        },

        mostrarMensagem() {
            return (
                this.finalizacao.status === 0 &&
                (this.finalizacao.qtdEntregas > 0 ||
                    this.finalizacao.qtdDespViagens > 0) &&
                this.finalizacao.qtdAnexos > 0 &&
                this.$temAcesso('CRED-FORN-FIN-04') &&
                !this.finalizacao.envioPermitido
            )
        }
    }
}
</script>
